import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface RejectReasonModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function RejectReasonModal({
  open,
  onClose,
  setOpen,
}: RejectReasonModalProps) {
  return (
    <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Rejection Reason</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label>Add Reason</label>
              <TextField
                placeholder="Enter Reason"
                fullWidth
                hiddenLabel
                multiline
                maxRows={5}
                minRows={5}
              ></TextField>
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
